import {CleanHtml, sanitizeHtml} from '@frontapp/editor-html';

import {
  emojiAllowedAttributes,
  inlineAttachmentAllowedAttributes,
  wrapMessageWithDivId,
} from './messageDraftHelpers';

export function sanitizeMessageDraftHtml(dirtyHtml: string, messageId?: number): CleanHtml {
  const wrappedDirtyHtml = wrapMessageWithDivId(dirtyHtml, messageId);
  return sanitizeHtml(wrappedDirtyHtml, {
    addAllowedAttributes: [...inlineAttachmentAllowedAttributes, ...emojiAllowedAttributes],
  });
}
